var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnify"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3398 3.91895C12.0638 3.91895 13.7171 4.60376 14.936 5.82275C16.155 7.04174 16.8398 8.69504 16.8398 10.4189C16.8398 12.0289 16.2498 13.5089 15.2798 14.6489L15.5498 14.9189H16.3398L21.3398 19.9189L19.8398 21.4189L14.8398 16.4189V15.6289L14.5698 15.3589C13.4298 16.3289 11.9498 16.9189 10.3398 16.9189C8.61594 16.9189 6.96264 16.2341 5.74365 15.0151C4.52466 13.7962 3.83984 12.1429 3.83984 10.4189C3.83984 8.69504 4.52466 7.04174 5.74365 5.82275C6.96264 4.60376 8.61594 3.91895 10.3398 3.91895ZM10.3398 5.91895C7.83984 5.91895 5.83984 7.91895 5.83984 10.4189C5.83984 12.9189 7.83984 14.9189 10.3398 14.9189C12.8398 14.9189 14.8398 12.9189 14.8398 10.4189C14.8398 7.91895 12.8398 5.91895 10.3398 5.91895Z",
    fill: "#818188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.42b1660a63b424f61d63178671cf901e.svg";
export { ForwardRef as ReactComponent };